import React, { FC, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import Button from '../../../components/button/button';
import FormCheckbox from '../../../components/formCheckbox/FormCheckbox';
import { DropdownOptions } from '../../../models/formModel';
import { riskControlFormQuestions } from '../../../models/reportModel';
import {
  RiskControlQuestionIds,
  useReportStore,
} from '../../../store/ReportStore';
import { ReportHandler } from '../Report';
import styles from '../Report.module.scss';

const RiskControlFormSection: FC<ReportHandler> = ({ validChanged }) => {
  const { controlReport, setControlReport } = useReportStore();

  const formMethods = useForm<RiskControlQuestionIds>({
    defaultValues: controlReport,
  });
  const {
    getValues,
    setValue,
    formState: { isValid },
  } = formMethods;

  useEffect(() => {
    return () => {
      setControlReport(getValues());
    };
  }, []);

  useEffect(() => {
    validChanged(isValid);
  }, [isValid]);

  const yesNoAnswer: DropdownOptions[] = [
    {
      label: 'Yes',
      value: 'yes',
    },
    {
      label: 'No',
      value: 'no',
    },
  ];
  const allQuestions = riskControlFormQuestions;

  const testerClick = () => {
    const randAns = () => (Math.random() > 0.5 ? 'yes' : 'no');
    allQuestions.forEach((q) => {
      q.questions.forEach((qtn) => setValue(qtn.id, randAns()));
    });
  };

  return (
    <>
      {window.location.href.includes('localhost:3001') && (
        <Button onClick={() => testerClick()}>Tester</Button>
      )}
      <FormProvider {...formMethods}>
        {allQuestions.map((questions) => {
          return (
            <div
              className={styles.riskControlFormContainer}
              key={questions.header}
            >
              <div className={styles.controlFormHeader}>{questions.header}</div>
              {questions.questions.map((q) => {
                return (
                  <FormCheckbox
                    key={q.id}
                    id={q.id}
                    label={q.question}
                    options={yesNoAnswer}
                    required
                  />
                );
              })}
            </div>
          );
        })}
      </FormProvider>
    </>
  );
};

export default RiskControlFormSection;
